import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { OrbitalMark } from '../shared/OrbitalMark'
import { MetricOdometer } from '../shared/MetricOdometer'
import { useScrollProgressValue } from '../../hooks/useScrollProgressValue'
import { yearsCoding, projectCount, languagesSpoken } from '../../data/profile'

export default function IdentitySection() {
    const { t } = useTranslation()
    const p = useScrollProgressValue('identity')

    const specs = [
        { label: 'HANDLE', value: t('identity.handle') },
        { label: 'BASE', value: t('identity.base') },
        { label: 'ROLE', value: t('identity.role') },
        { label: 'SPECIALTY', value: t('identity.specialty') },
    ]

    const stats = [
        { target: yearsCoding, fmt: 'plus', label: 'YEARS' },
        { target: projectCount, fmt: 'plus', label: 'PROJECTS' },
        { target: languagesSpoken, fmt: 'plain', label: 'LANGUAGES' },
    ]

    return (
        <SectionShell id="identity">
            <div className="section-head">
                <span className="section-num">01</span>
                <span className="section-label">{t('identity.label')}</span>
            </div>

            <div className="identity-layout">
                <div className="identity-spec-sheet">
                    {specs.map(({ label, value }) => (
                        <div key={label} className="identity-spec-row">
                            <span className="identity-spec-key">{label}</span>
                            <span className="identity-spec-val">{value}</span>
                        </div>
                    ))}
                </div>

                <div className="identity-orb-col">
                    <OrbitalMark width={160} height={160} className="identity-mark" />
                    <p className="identity-name">{t('identity.name')}</p>
                </div>
            </div>

            <div className="identity-stats">
                {stats.map(({ target, fmt, label }) => (
                    <div key={label} className="identity-stat-orb">
                        <div className="identity-stat-value">
                            <MetricOdometer target={target} progress={p} fmt={fmt} />
                        </div>
                        <div className="identity-stat-label">{label}</div>
                    </div>
                ))}
            </div>
        </SectionShell>
    )
}
